import { Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";

/**
 * Instructions modal component
 *
 * @param {Object} props
 * @param {Boolean} props.isOpen
 * @param {Function} props.closeModal
 * @returns {JSX.Element}
 */
export default function InstructionsModal({ isOpen, closeModal }) {
    const modalRef = useRef(null);

    if (modalRef.current) {
        modalRef.current.scrollTop = 0;
    }

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={() => {}}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-75" />
                </Transition.Child>

                <div
                    className="fixed inset-0 overflow-y-auto"
                    ref={modalRef}
                    dusk="intructions-modal"
                >
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-xl transform overflow-hidden rounded-2xl bg-white px-8 py-12 text-left align-middle shadow-xl transition-all">
                                <Dialog.Title
                                    as="h3"
                                    className="text-2xl text-center font-medium leading-6 text-gray-900"
                                >
                                    Toma una selfie
                                </Dialog.Title>
                                <div className="mt-2">
                                    <p className="text-base text-black text-center">
                                        Alinea tu rostro y ojos con las líneas y
                                        sigue estos pasos para obtener el mejor
                                        escaneo.
                                    </p>
                                </div>

                                <div className="grid grid-cols-2 gap-6 mt-8">
                                    <div className="flex items-center w-full md:w-5/6 mx-auto flex-col">
                                        <div className="w-20 h-20 md:w-28 md:h-28 rounded-full bg-[#e4eefc] flex justify-center items-center mb-3">
                                            <img
                                                src="/img/selfie_step_one.svg"
                                                alt=""
                                                className="h-16 w-16 object-contain"
                                            />
                                        </div>
                                        <div className="w-full">
                                            <p className="text-base text-center">
                                                Retira tu cabello hacia atrás y
                                                elimina cualquier cosa que tape
                                                tu rostro.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center w-full md:w-5/6 mx-auto flex-col">
                                        <div className="w-20 h-20 md:w-28 md:h-28 rounded-full bg-[#e4eefc] flex justify-center items-center mb-3">
                                            <img
                                                src="/img/selfie_step_two.svg"
                                                alt=""
                                                className="h-16 w-16 object-contain"
                                            />
                                        </div>
                                        <div className="w-full">
                                            <p className="text-base text-center">
                                                Usa un área bien iluminada para
                                                escanear tu cara.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center w-full md:w-5/6 mx-auto flex-col">
                                        <div className="w-20 h-20 md:w-28 md:h-28 rounded-full bg-[#e4eefc] flex justify-center items-center mb-3">
                                            <img
                                                src="/img/selfie_step_three.svg"
                                                alt=""
                                                className="h-16 w-16 object-contain"
                                            />
                                        </div>
                                        <div className="w-full">
                                            <p className="text-base text-center">
                                                Relaja tu rostro. Sin sonreír.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center w-full md:w-5/6 mx-auto flex-col">
                                        <div className="w-20 h-20 md:w-28 md:h-28 rounded-full bg-[#e4eefc] flex justify-center items-center mb-3">
                                            <img
                                                src="/img/selfie_step_four.svg"
                                                alt=""
                                                className="h-16 w-16 object-contain"
                                            />
                                        </div>
                                        <div className="w-full">
                                            <p className="text-base text-center">
                                                Relaja tu rostro. Sin sonreír.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-8 flex justify-center">
                                    <button
                                        type="button"
                                        dusk="close-instructions-modal"
                                        className="inline-flex outline-none justify-center border border-transparent bg-primary-400 px-4 py-2 text-sm font-medium text-white w-44"
                                        onClick={closeModal}
                                    >
                                        SIGUIENTE
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}
